<template>
  <div>
    <Header>
      Edycja grafiku
    </Header>

    <b-row>
      <b-col xl="6">
        <Errors/>

        <b-form-group label="Zajętość dnia:">
          <b-progress :max="schedule.max_reservations">
            <b-progress-bar :value="active_reservations_count" variant="success">
              {{ active_reservations_count }}
            </b-progress-bar>
            <b-progress-bar :value="schedule.max_reservations - reservations_count" variant="transparent">
              <span class="text-dark">
                {{ schedule.max_reservations - reservations_count }}
              </span>
            </b-progress-bar>
            <b-progress-bar :value="blocked_reservations_count" variant="danger">
              {{ blocked_reservations_count }}
            </b-progress-bar>
          </b-progress>
        </b-form-group>

        <b-form-group>
          <b-table-simple small borderless class="mb-0">
            <b-tbody>
              <b-tr>
                <b-td class="w-1 text-right">Fryzjer:</b-td>
                <b-th>
                  {{ schedule.barber.name }}
                </b-th>
              </b-tr>
              <b-tr>
                <b-td class="w-1 text-right">Data:</b-td>
                <b-th>
                  {{ schedule.date_string }}
                </b-th>
              </b-tr>
              <b-tr>
                <b-td class="w-1 text-right">Godziny:</b-td>
                <b-th>
                  {{ schedule.start_hour }} -
                  {{ schedule.end_hour }}
                </b-th>
              </b-tr>
              <b-tr>
                <b-td class="w-1 text-right">Czas:</b-td>
                <b-th>
                  {{ schedule.duration }} min
                </b-th>
              </b-tr>
              <b-tr>
                <b-td class="w-1 text-right">Widoczność:</b-td>
                <b-th>
                  <span v-if="form.isOnline" class="text-success">online + telefonicznie</span>
                  <span v-else class="text-danger">tylko telefonicznie</span>
                </b-th>
              </b-tr>
            </b-tbody>
          </b-table-simple>
        </b-form-group>

        <b-form @submit.prevent="submit">
          <b-form-group>
            <b-checkbox v-model="form.isOnline">
              Rezerwacje online
            </b-checkbox>
          </b-form-group>
          <b-form-group label="Godziny:">
            <b-row>
              <b-col>
                <b-form-group label="Od:">
                  <b-form-input v-model="startTime" type="time" step="900" size="lg" :state="startTimeState"/>
                  <b-form-invalid-feedback :state="startTimeState">
                    Minuty muszą być co 15 (00, 15, 30, 45)
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group label="Do:">
                  <b-form-input v-model="endTime" type="time" step="900" size="lg" :state="endTimeState"/>
                  <b-form-invalid-feedback :state="endTimeState">
                    Minuty muszą być co 15 (00, 15, 30, 45)
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>
          </b-form-group>
          <b-form-group>
            <div class="d-flex justify-content-between">
              <div>
                <inertia-link
                  :href="route('schedules.index')"
                  as="b-button"
                  variant="secondary"
                >
                  <b-icon icon="x"/>
                  Anuluj
                </inertia-link>
                <b-button
                  :variant="hasReservations ? 'secondary' : 'danger'"
                  :disabled="hasReservations"
                  @click="deleteSchedule"
                >
                  <b-icon icon="trash"/>
                </b-button>
              </div>
              <div>
                <b-button type="submit" variant="primary" :disabled="form.processing || hasInvalidTime">
                  <b-icon icon="check"/>
                  Zapisz
                </b-button>
              </div>
            </div>
          </b-form-group>
        </b-form>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Layout from '@/Layouts/Default'
import Header from '@/Layouts/Components/Header'
import Errors from '@/Layouts/Components/Errors'

export default {
  components: {
    Header,
    Errors,
  },
  layout: Layout,
  props: {
    schedule: Object,
    reservations_count: Number,
    active_reservations_count: Number,
    blocked_reservations_count: Number,
  },
  data() {
    return {
      form: this.$inertia.form({
        isOnline: this.schedule.is_online || false,
        startAt: `${this.schedule.start_hour}:00` || '',
        endAt: `${this.schedule.end_hour}:00` || '',
      }),
      formDelete: this.$inertia.form({}),
    }
  },
  computed: {
    hasReservations() {
      return this.active_reservations_count > 0
    },
    // Bridge the form's "HH:MM:SS" value to the native time input's "HH:MM"
    startTime: {
      get() {
        return this.form.startAt ? this.form.startAt.slice(0, 5) : ''
      },
      set(value) {
        this.form.startAt = value ? `${value}:00` : ''
      },
    },
    endTime: {
      get() {
        return this.form.endAt ? this.form.endAt.slice(0, 5) : ''
      },
      set(value) {
        this.form.endAt = value ? `${value}:00` : ''
      },
    },
    startTimeState() {
      return this.timeStepState(this.form.startAt)
    },
    endTimeState() {
      return this.timeStepState(this.form.endAt)
    },
    hasInvalidTime() {
      return this.startTimeState === false || this.endTimeState === false
    },
  },
  methods: {
    submit() {
      if (this.hasInvalidTime) return

      this.form.put(this.route('schedules.update', this.schedule.id))
    },
    // false (invalid) when minutes are not a multiple of 15, otherwise null (no styling)
    timeStepState(value) {
      if (!value) {
        return null
      }
      return Number(value.slice(3, 5)) % 15 === 0 ? null : false
    },
    async deleteSchedule() {
      const confirmation = await this.$bvModal.msgBoxConfirm(
        'Czy na pewno chcesz usunąć?',
        {
          title: 'Usuwanie',
          okVariant: 'danger',
          okTitle: 'Usuń',
          cancelTitle: 'Anuluj',
          cancelVariant: 'light',
          hideHeaderClose: false,
          centered: true,
        }
      )
      if (!confirmation) return

      this.formDelete.delete(this.route('schedules.destroy', this.schedule.id))
    },
  },
}
</script>
